import React, { useEffect, useState } from "react";
import NextButton from "../Component/NextButton";
import BackButton from "../Component/BackButton";
import { Undo2, Volume2, VolumeX } from "lucide-react";
import CartChatpterComp from "./CartChatpterComp";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function Listen_find({ listen_find, picture }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [isPlaying, setIsPlaying] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [userAnswer, setUserAnswer] = useState([]);
  const [userAllContent, setUserAllContent] = useState({
    userId: "",
    name: "",
    class_name: "",
    listen_find: null,
  });
  const [value, setValue] = useState(false);
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();
  const contentValue = useSelector((state) => state.extra.value);
  const user = JSON.parse(localStorage.getItem("postUser"));

  const currentItem = listen_find[currentIndex];
  useEffect(() => {
    if (currentIndex === listen_find.length) {
      setUserAllContent({
        userId: user._id,
        name: contentValue.name,
        class_name: contentValue.class_name,
        listen_find: userAnswer,
      });
      setValue(true);
      setTab(2);
    }
  }, [currentIndex, listen_find.length]);

  // Seslendirme Fonksiyonu
  const speak = (text) => {
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.rate = 0.8;

    utterance.onstart = () => setIsPlaying(true);
    utterance.onend = () => setIsPlaying(false);

    window.speechSynthesis.speak(utterance);
  };

  const handleNextButton = () => {
    if (currentIndex < listen_find.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setIsPlaying(false);
    }
  };

  const handleBackButton = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setIsPlaying(false);
    }
  };

  // const currentItem = listen_find[currentIndex];

  const handleChoice = (choice) => {
    if (answers[currentIndex] || isWaiting) return;
    setAnswers({ ...answers, [currentIndex]: choice });
    setIsWaiting(true);
    let choiseStatus = false;
    if (listen_find[currentIndex].status === choice) {
      choiseStatus = true;
    }
    setUserAnswer((prev) => [
      ...prev,
      {
        sentenceId: listen_find[currentIndex]._id,
        sentence: listen_find[currentIndex].sentence,
        givenAnswer: choice,
        status: choiseStatus,
      },
    ]);
    setTimeout(() => {
      setCurrentIndex((prev) => prev + 1);
      setIsWaiting(false);
    }, 1000);
  };

  // useEffect(() => {
  //   if (currentIndex === listen_find.length) {
  //     setUserAllContent({
  //       userId: user._id,
  //       name: contentValue.name,
  //       class_name: contentValue.class_name,
  //       listen_find: userAnswer,
  //     });
  //     setValue(true);
  //     setTab(2);
  //   }
  // }, [currentIndex, listen_find.length]);

  if (tab === 2) {
    return (
      <CartChatpterComp
        value={value}
        status="listen_find"
        userAllContent={userAllContent}
      />
    );
  }

  if (currentIndex >= listen_find.length) {
    return null;
  }

  return (
    <div className="flex flex-col w-full gap-4 max-w-5xl mx-auto rounded-xl">
      <div className="grid grid-cols-4 p-2 items-center w-full gap-4 bg-yellow-500 rounded-xl">
        {/* Sol Kısım: Egzersiz Başlığı */}
        <div className="col-span-3 md:col-span-3 flex items-center">
          <span className="font-medium rounded-xl text-white text-lg p-2">
            Listen & Find
          </span>
        </div>

        {/* Sağ Kısım: Geri Dön Butonu */}
        <div className="col-span-1 md:col-span-1 flex justify-end items-center">
          <button
            onClick={() => navigate("/extraPage")}
            className="bg-gray-100 h-10 w-10 text-red-500 hover:bg-red-500
             hover:text-gray-100 transition-all rounded-full
             flex items-center justify-center shadow-lg active:scale-90 shrink-0"
          >
            <Undo2 size={20} />
          </button>
        </div>
      </div>
      <div
        className="flex flex-col w-full bg-purple-500 gap-4 max-w-5xl mx-auto rounded-xl shadow-2xl"
        style={{ fontFamily: "Inter, system-ui, -apple-system, sans-serif" }}
      >
        {/* ORTA KISIM: Görsel ve Navigasyon Butonları */}
        <div className="flex flex-row items-center justify-between gap-4">
          {/* Geri Butonu */}
          {/* <div
            className={
              currentIndex === 0 ? "opacity-30 pointer-events-none" : ""
            }
          >
            <BackButton handleBackButton={handleBackButton} />
          </div> */}

          {/* Ana Görsel Alanı */}
          <div className="flex-1 flex flex-col items-center gap-4">
            <div className="grid grid-cols-12 p-2 justify-center items-center w-full gap-2 md:gap-4">
              {/* Geri Butonu */}
              <div
                className={`col-span-2 sm:col-span-1 flex justify-start items-center ${
                  currentIndex === 0 ? "opacity-30 pointer-events-none" : ""
                }`}
              >
                <BackButton handleBackButton={handleBackButton} />
              </div>

              {/* Orta Kısım (Noktalar / Progress) */}
              <div className="col-span-8 sm:col-span-10 flex justify-center items-center">
                <div className="flex flex-wrap justify-center items-center gap-2 p-2 rounded-2xl max-w-full">
                  {listen_find.map((_, i) => {
                    const isAnswered =
                      answers[i] !== undefined && answers[i] !== null;
                    const isCorrect = answers[i] === listen_find[i].status;
                    return (
                      <div
                        key={i}
                        className={`w-3 h-3 rounded-full transition-all duration-300 ${
                          i === currentIndex
                            ? "bg-yellow-400 scale-150 shadow-md"
                            : isAnswered
                              ? isCorrect
                                ? "bg-green-400"
                                : "bg-red-400"
                              : "bg-purple-300"
                        }`}
                      />
                    );
                  })}
                </div>
              </div>

              {/* İleri Butonu */}
              <div
                className={`col-span-2 sm:col-span-1 flex justify-end items-center ${
                  currentIndex === listen_find.length - 1
                    ? "opacity-30 pointer-events-none"
                    : ""
                }`}
              >
                <NextButton handleNextButton={handleNextButton} />
              </div>
            </div>
            <div
              className="w-full max-w-2xl rounded-2xl shadow-inner relative
             border-l-6 border-yellow-500 min-h-[120px]"
            >
              <img
                src={picture}
                alt="Exercise"
                className="w-full h-full rounded-xl aspect-video"
              />
            </div>

            {/* bilgisayar ve tablet için */}
            <div className="w-full max-w-2xl lg:grid grid-cols-12 rounded-xl p-6 gap-4 text-center items-stretch hidden">
              {/* 🟢 TRUE BUTONU */}
              {(() => {
                const option = "true";
                const isSelected = answers[currentIndex] === option;
                const isCorrectAnswer = currentItem.status === option;
                const hasAnswered = answers[currentIndex] !== undefined;

                let buttonStyle =
                  "bg-yellow-400 hover:bg-yellow-300 border-yellow-500 text-gray-800";

                if (hasAnswered) {
                  if (isCorrectAnswer) {
                    buttonStyle =
                      "bg-green-500 text-white border-green-600 shadow-lg scale-105";
                  } else if (isSelected) {
                    buttonStyle =
                      "bg-red-500 text-white border-red-600 opacity-70";
                  } else {
                    buttonStyle =
                      "bg-purple-400 text-purple-200 border-purple-500 opacity-40 pointer-events-none";
                  }
                }

                return (
                  <button
                    disabled={hasAnswered || isWaiting}
                    onClick={() => handleChoice(option)}
                    className={`col-span-3 flex flex-col justify-center items-center gap-2 rounded-2xl py-4
                      transition-all duration-200 active:scale-95 cursor-pointer select-none ${buttonStyle}`}
                  >
                    <span className="p-2 rounded-full bg-purple-600 text-white text-md">
                      {hasAnswered && isCorrectAnswer ? "⭐" : "✅"}
                    </span>
                    <span className="text-xl font-bold uppercase tracking-wide">
                      true
                    </span>
                  </button>
                );
              })()}

              {/* 🟡 ORTA KISIM: LISTEN SES BUTONU VE CEVAP ALANI */}
              <div
                className="bg-gray-100 col-span-6 flex flex-col justify-center items-center gap-2 rounded-2xl
             p-4 shadow-md border-l-4 border-yellow-500 min-h-[120px]"
              >
                <button
                  disabled={isWaiting}
                  onClick={() => speak(currentItem.sentence)}
                  className={`group relative flex items-center justify-center w-40 h-12 rounded-xl 
                  transition-all duration-300 shadow-md gap-2 ${
                    isPlaying
                      ? "bg-orange-500 scale-105 shadow-orange-300"
                      : "bg-purple-600 hover:bg-purple-700 active:scale-95 text-white"
                  }`}
                >
                  <span className="text-white font-black text-sm tracking-widest uppercase">
                    {isPlaying ? "Listening" : "Listen"}
                  </span>
                  {isPlaying ? (
                    <Volume2 className="text-white animate-pulse" size={20} />
                  ) : (
                    <VolumeX className="text-white" size={20} />
                  )}
                </button>

                {/* Cevap verildikten sonra açılan metin pekiştirmesi */}
                {answers[currentIndex] !== undefined && (
                  <div className="flex flex-col items-center gap-1 mt-1">
                    <p className="text-sm font-bold text-purple-950 leading-tight">
                      {currentItem.sentence} {currentItem.emoji}
                    </p>
                    <span
                      className={`text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded-full bg-white bg-opacity-30 ${
                        answers[currentIndex] === currentItem.status
                          ? "text-green-950"
                          : "text-red-950"
                      }`}
                    >
                      {answers[currentIndex] === currentItem.status
                        ? "Well Done! ⭐"
                        : "Try Again! 💪"}
                    </span>
                  </div>
                )}
              </div>

              {/* 🔴 FALSE BUTONU */}
              {(() => {
                const option = "false";
                const isSelected = answers[currentIndex] === option;
                const isCorrectAnswer = currentItem.status === option;
                const hasAnswered = answers[currentIndex] !== undefined;

                let buttonStyle =
                  "bg-yellow-400 hover:bg-yellow-300 border-yellow-500 text-gray-800";

                if (hasAnswered) {
                  if (isCorrectAnswer) {
                    buttonStyle =
                      "bg-green-500 text-white border-green-600 shadow-lg scale-105";
                  } else if (isSelected) {
                    buttonStyle =
                      "bg-red-500 text-white border-red-600 opacity-70";
                  } else {
                    buttonStyle =
                      "bg-purple-400 text-purple-200 border-purple-500 opacity-40 pointer-events-none";
                  }
                }

                return (
                  <button
                    disabled={hasAnswered || isWaiting}
                    onClick={() => handleChoice(option)}
                    className={`col-span-3 flex flex-col justify-center items-center gap-2 rounded-2xl
                     py-4  transition-all duration-200 active:scale-95 cursor-pointer select-none ${buttonStyle}`}
                  >
                    <span className="p-2 rounded-full bg-purple-600 text-white text-md">
                      {hasAnswered && isCorrectAnswer ? "⭐" : "❌"}
                    </span>
                    <span className="text-xl font-bold uppercase tracking-wide">
                      false
                    </span>
                  </button>
                );
              })()}
            </div>
            {/* telefon için */}
            <div className="w-full max-w-2xl grid grid-rows-2 rounded-xl p-6 gap-4 text-center items-stretch lg:hidden ">
              {/* 🟡 ORTA KISIM: LISTEN SES BUTONU VE CEVAP ALANI */}
              <div
                className="bg-gray-100 row-span-1 flex flex-col justify-center items-center gap-2 rounded-2xl
             p-4 shadow-md border-l-4 border-yellow-500 min-h-[120px]"
              >
                <button
                  disabled={isWaiting}
                  onClick={() => speak(currentItem.sentence)}
                  className={`group relative flex items-center justify-center w-40 h-12 rounded-xl 
                  transition-all duration-300 shadow-md gap-2 ${
                    isPlaying
                      ? "bg-orange-500 scale-105 shadow-orange-300"
                      : "bg-purple-600 hover:bg-purple-700 active:scale-95 text-white"
                  }`}
                >
                  <span className="text-white font-black text-sm tracking-widest uppercase">
                    {isPlaying ? "Listening" : "Listen"}
                  </span>
                  {isPlaying ? (
                    <Volume2 className="text-white animate-pulse" size={20} />
                  ) : (
                    <VolumeX className="text-white" size={20} />
                  )}
                </button>

                {/* Cevap verildikten sonra açılan metin pekiştirmesi */}
                {answers[currentIndex] !== undefined && (
                  <div className="flex flex-col items-center gap-1 mt-1">
                    <p className="text-sm font-bold text-purple-950 leading-tight">
                      {currentItem.sentence} {currentItem.emoji}
                    </p>
                    <span
                      className={`text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded-full bg-white bg-opacity-30 ${
                        answers[currentIndex] === currentItem.status
                          ? "text-green-950"
                          : "text-red-950"
                      }`}
                    >
                      {answers[currentIndex] === currentItem.status
                        ? "Well Done! ⭐"
                        : "Try Again! 💪"}
                    </span>
                  </div>
                )}
              </div>
              <div className="row-span-1 flex justify-between items-center gap-2 ">
                {/* 🟢 TRUE BUTONU */}
                {(() => {
                  const option = "true";
                  const isSelected = answers[currentIndex] === option;
                  const isCorrectAnswer = currentItem.status === option;
                  const hasAnswered = answers[currentIndex] !== undefined;

                  let buttonStyle =
                    "bg-yellow-400 hover:bg-yellow-300  border-yellow-500 text-gray-800";

                  if (hasAnswered) {
                    if (isCorrectAnswer) {
                      buttonStyle =
                        "bg-green-500 text-white border-green-600 shadow-lg scale-105";
                    } else if (isSelected) {
                      buttonStyle =
                        "bg-red-500 text-white border-red-600 opacity-70";
                    } else {
                      buttonStyle =
                        "bg-purple-400 text-purple-200 border-purple-500 opacity-40 pointer-events-none";
                    }
                  }

                  return (
                    <button
                      disabled={hasAnswered || isWaiting}
                      onClick={() => handleChoice(option)}
                      className={` flex flex-col w-full justify-center items-center gap-2 rounded-2xl py-4
                      transition-all duration-200 active:scale-95 cursor-pointer select-none ${buttonStyle}`}
                    >
                      <span className="p-2 rounded-full bg-purple-600 text-white text-md">
                        {hasAnswered && isCorrectAnswer ? "⭐" : "✅"}
                      </span>
                      <span className="text-xl font-bold uppercase tracking-wide">
                        true
                      </span>
                    </button>
                  );
                })()}
                {/* 🔴 FALSE BUTONU */}
                {(() => {
                  const option = "false";
                  const isSelected = answers[currentIndex] === option;
                  const isCorrectAnswer = currentItem.status === option;
                  const hasAnswered = answers[currentIndex] !== undefined;

                  let buttonStyle =
                    "bg-yellow-400 hover:bg-yellow-300 border-yellow-500 text-gray-800";

                  if (hasAnswered) {
                    if (isCorrectAnswer) {
                      buttonStyle =
                        "bg-green-500 text-white border-green-600 shadow-lg scale-105";
                    } else if (isSelected) {
                      buttonStyle =
                        "bg-red-500 text-white border-red-600 opacity-70";
                    } else {
                      buttonStyle =
                        "bg-purple-400 text-purple-200 border-purple-500 opacity-40 pointer-events-none";
                    }
                  }

                  return (
                    <button
                      disabled={hasAnswered || isWaiting}
                      onClick={() => handleChoice(option)}
                      className={`col-span-3 flex flex-col w-full justify-center items-center gap-2 rounded-2xl
                     py-4  transition-all duration-200 active:scale-95 cursor-pointer select-none ${buttonStyle}`}
                    >
                      <span className="p-2 rounded-full bg-purple-600 text-white text-md">
                        {hasAnswered && isCorrectAnswer ? "⭐" : "❌"}
                      </span>
                      <span className="text-xl font-bold uppercase tracking-wide">
                        false
                      </span>
                    </button>
                  );
                })()}
              </div>
            </div>
          </div>

          {/* İleri Butonu */}
          {/* <div
            className={
              currentIndex === listen_find.length - 1
                ? "opacity-30 pointer-events-none"
                : ""
            }
          >
            <NextButton handleNextButton={handleNextButton} />
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Listen_find;
